module.exports = __webpack_public_path__ + "img/header-logo.e8ae7375.png";